import type { ReactNode } from 'react'
import { Box, Button, Typography } from '@mui/material'

interface AdminEmptyStateProps {
  icon: ReactNode
  title: string
  description: string
  actionLabel?: string
  onAction?: () => void
  compact?: boolean
}

export function AdminEmptyState({ icon, title, description, actionLabel, onAction, compact }: AdminEmptyStateProps) {
  return (
    <Box sx={{
      minHeight: compact ? 170 : 250, px: 3, py: compact ? 3 : 5,
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center',
    }}>
      <Box sx={{
        width: compact ? 42 : 52, height: compact ? 42 : 52, borderRadius: 3,
        bgcolor: 'primary.50', color: 'primary.main', display: 'grid', placeItems: 'center', mb: 1.5,
        '& svg': { fontSize: compact ? 21 : 26 },
      }}>
        {icon}
      </Box>
      <Typography variant="body2" fontWeight={750} color="text.primary">{title}</Typography>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, maxWidth: 380, lineHeight: 1.55 }}>
        {description}
      </Typography>
      {actionLabel && onAction && (
        <Button size="small" variant="outlined" onClick={onAction} sx={{ mt: 2 }}>{actionLabel}</Button>
      )}
    </Box>
  )
}
